import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackContextDomainSubmitted.meta';

export type UseTrackContextDomainSubmittedParams = {
  domain: string;
  source: 'onboarding' | 'manual';
};

export const useTrackContextDomainSubmitted = () => {
  const { track } = useAnalyticsUtilities();

  const trackContextDomainSubmitted = useCallback(
    (params: UseTrackContextDomainSubmittedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackContextDomainSubmitted };
};
